<template>
	<div>
		<v-data-table
			v-if="hasItens"
			:headers="colunas"
			:items="itens"
			item-key="id"
			hide-default-footer
			:server-items-length="totalItens"
			:options="paginacaoInterna"
			class="arp-listview mt-5 row-pointer"
		>
			<template #item.orgao="{ item }">
				<v-tooltip color="black" bottom>
					<template #activator="{ on }">
						<v-icon
							v-show="item.isCessionario"
							v-on="on"
							class="arp_icone_cessionario"
							v-az-auth="permissoes.fornecedorItemAtaPrincipalComAderentesListar"
							>mdi-alpha-c-circle-outline
						</v-icon>
					</template>
					Órgão é Cessionário
				</v-tooltip>
				<span> {{ item.siglaOrgao }} </span>
			</template>
			<template #item.estoque="{ item }">
				<span class="pr-2">
					{{ item.estoque | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}
				</span>
			</template>
			<template #[`item.acoes`]="{ item }">
				<div class="d-flex flex-row justify-space-between align-content-center px-0">
					<botao-tooltip-datatable
						icone="mdi-swap-horizontal"
						cor="grey"
						texto="Remanejar"
						@click="$emit('transferir-saldo', item)"
					></botao-tooltip-datatable>
				</div>
			</template>
		</v-data-table>

		<template-listagem-vazia
			:total-itens="totalItens"
			:textos="textosDoTemplateDaListagemVazia"
		></template-listagem-vazia>

		<paginacao-tabela
			v-if="totalItens > 0"
			:page.sync="paginacaoInterna.page"
			:rows-per-page.sync="paginacaoInterna.rowsPerPage"
			:totalPaginas="totalPaginas"
			:totalItens="totalItens"
			@resetar-page="resetarPage"
		></paginacao-tabela>
	</div>
</template>
<script>
import tabelaMixin from '@/views/mixins/tabela'
import { TabelaColunaUtils } from '@/core/utils'
import { mapGetters, mapState } from 'vuex'
import { getterTypes, mutationTypes } from '@/core/constants'
import validacaoAta from '@/views/mixins/validacaoAta'

export default {
	name: 'acessar-transferencia-listagem',
	mixins: [tabelaMixin, validacaoAta],
	props: {
		itens: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			textosDoTemplateDaListagemVazia: {
				titulo: 'Nenhum item de pedido por aqui',
			},
			paginacaoInterna: this.paginacao,
			colunas: this.getColunasTabela(),
		}
	},
	computed: {
		...mapState({
			informacoesPedido: (state) => state.pedido.informacoesPedido,
		}),
		...mapGetters({
			isPedidoRascunho: getterTypes.PEDIDO.IS_PEDIDO_RASCUNHO,
		}),
		numeroCasasDecimaisQtde: {
			get() {
				return this.$store.state.ata.informacoesAta.numeroCasasDecimaisQtde
			},
		},
	},
	beforeDestroy() {
		this.$store.commit(mutationTypes.ITEM_ATA.TRANSFERENCIA.TRANSFERIR.RESETAR_PAGINA_LISTAGEM)
		this.$store.commit(mutationTypes.ITEM_ATA.TRANSFERENCIA.TRANSFERIR.RESET_JUSTIFICATIVA)
		this.$store.commit(mutationTypes.ITEM_ATA.TRANSFERENCIA.TRANSFERIR.RESET_DATASOURCE)
	},
	methods: {
		getColunasTabela() {
			const colunas = []

			colunas.push(new TabelaColunaUtils('Órgão', 'orgao', '20%'))
			colunas.push(new TabelaColunaUtils('Saldo', 'estoque', '50%'))
			colunas.push(new TabelaColunaUtils('Ações', 'acoes', '30%'))

			return colunas
		},
		resetarPage() {
			this.$emit('resetar-page')
		},
	},
}
</script>
<style lang="stylus">
.arp_icon_and_text
	> i
		margin-right 2px


.arp_icone_cessionario
	background-color: transparent;
	border-radius: 50%;
	color: var(--v-primary-base)!important;
	float: left;
	margin-right: 5px;
	font-size: 20px !important;
</style>
